(function () {
  var BREAKPOINT = 769;

  function initCompareTable(el) {
    // Prevent double-init on the same element
    if (el.hasAttribute("data-ct-init")) return;
    el.setAttribute("data-ct-init", "");

    var swiperInstance = null;
    var resizeTimer;

    // The shopify-block wrapper is the actual swiper-slide — target that, not the inner column
    var labelsSlide = el.querySelector(".swiper-wrapper > .swiper-slide");

    // Pinned-featured layout nodes (mobile only) — set in initSwiper, torn down in destroySwiper
    var row = null; // .compare-table__mobile-row flex wrapper
    var pinned = null; // .compare-table__pinned holding the featured slide
    var featuredSlide = null; // the .swiper-slide lifted out of the swiper
    var featuredNext = null; // original next sibling, for restore order
    var swiperWrapper = el.querySelector(".swiper-wrapper");
    var section = el.closest(".compare-table");
    var controls = section
      ? section.querySelector("[data-compare-table-controls]")
      : null;
    var pagination = controls
      ? controls.querySelector(".swiper-pagination")
      : null;
    var prevBtn = controls
      ? controls.querySelector(".compare-table__nav-prev")
      : null;
    var nextBtn = controls
      ? controls.querySelector(".compare-table__nav-next")
      : null;

    // ─── Mobile: Swiper ─────────────────────────────────────────────────────

    function destroySwiper() {
      if (!swiperInstance) return;
      swiperInstance.destroy(true, true);
      swiperInstance = null;

      // Tear down the pinned-featured layout, restoring the original DOM
      if (row) {
        // Featured slide back into the wrapper at its original position
        if (featuredSlide && swiperWrapper) {
          swiperWrapper.insertBefore(featuredSlide, featuredNext);
        }
        // Swiper back where the row currently sits, then drop the row
        row.parentNode.insertBefore(el, row);
        row.remove();
        row = null;
        pinned = null;
        featuredSlide = null;
        featuredNext = null;
      }

      if (labelsSlide) {
        labelsSlide.classList.add("swiper-slide");
      }

      // Clear any residual Swiper inline styles from all slides
      el.querySelectorAll(".swiper-wrapper > .swiper-slide").forEach(
        function (s) {
          s.style.cssText = "";
        },
      );
    }

    function initSwiper() {
      if (window.innerWidth >= BREAKPOINT) return;
      if (swiperInstance) return;

      // Swiper may still be loading (defer) — retry in 100 ms
      if (typeof Swiper === "undefined") {
        setTimeout(initSwiper, 100);
        return;
      }

      // Pull the labels slide out before Swiper reads the DOM
      if (labelsSlide) {
        labelsSlide.classList.remove("swiper-slide");
        labelsSlide.style.display = "none";
      }

      // Lift the featured column out of the swiper and pin it on the left
      var featuredColumn = el.querySelector(".compare-table__column--featured");
      featuredSlide = featuredColumn
        ? featuredColumn.closest(".swiper-slide")
        : null;

      var paginationEl = pagination;

      if (featuredSlide) {
        featuredNext = featuredSlide.nextSibling;

        row = document.createElement("div");
        row.className = "compare-table__mobile-row";

        pinned = document.createElement("div");
        pinned.className = "compare-table__pinned";

        el.parentNode.insertBefore(row, el);
        pinned.appendChild(featuredSlide);
        row.appendChild(pinned);
        row.appendChild(el);
      }

      swiperInstance = new Swiper(el, {
        // 1 per view next to the pinned featured column = 2 in view;
        // 2 per view as graceful fallback when no featured column exists
        slidesPerView: featuredSlide ? 1 : 2,
        // Only 1 swiper slide is visible at a time when pinned, so no
        // inter-slide spacing is needed — a trailing margin would over-
        // translate the last slide and clip the edge slides. The visible
        // separation from the pinned card is the row's flex gap. The
        // fallback shows 2 slides at once, so it keeps the 8px spacing.
        spaceBetween: featuredSlide ? 0 : 8,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        grabCursor: true,
        loop: false,
        roundLengths: true, // integer slide widths/translates — no sub-pixel edge clipping
        observer: true,
        observeParents: true,
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      });
    }

    // ─── Init & resize ───────────────────────────────────────────────────────

    if (window.innerWidth < BREAKPOINT) {
      initSwiper();
    }

    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (window.innerWidth >= BREAKPOINT) {
          destroySwiper();
        } else if (!swiperInstance) {
          initSwiper();
        }
      }, 150);
    });
  }

  // ─── Find and init all compare table instances ──────────────────────────

  function setup() {
    document.querySelectorAll("[data-compare-table]").forEach(initCompareTable);
  }

  // Works for normal page load and theme-editor re-renders
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setup);
  } else {
    setup();
  }

  // Re-init when a section is added or reloaded in the Shopify theme editor
  document.addEventListener("shopify:section:load", function (e) {
    var sectionEl = e.target.querySelector("[data-compare-table]");
    if (sectionEl) {
      sectionEl.removeAttribute("data-ct-init");
      initCompareTable(sectionEl);
    }
  });
})();
